import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const plotSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  property_map_classification_id: required({ t })(Yup.string()),
  observation: Yup.string(),
  coordinates: Yup.array().of(
    Yup.object().shape({ lat: Yup.string(), long: Yup.string() })
  )
})

export default plotSchema
